import { useState } from "react";
import { Button, CustomSelect, RangeDate } from "../../../components";
import "../../../antd.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllGroups, getAllResponsesFormProject } from "../../../redux/VRL/thunks";
import { setProyectSelected } from "../../../redux/VRL/vrlSlice";
import { getAllResponsesTrainingFormProject } from "../../../redux/VRT/thunks";
import { setProyectSelectedTraining } from "../../../redux/VRT/vrtSlice";

export const PrincipalHeader = ({ hasFilter, setFilter, dateRange, setDataRange, callback }) => {
    // const [, setSelectItem] = useState(options[0] ? options[0]._id : null);
    const { proyects, proyectSelected } = useSelector((state) => state.vrlSlice);

    const { typeAdmin } = useSelector((state) => state.auth)
    const [itemSelected, setSelectItem] = useState(proyectSelected._id);
    const dispatch = useDispatch()
    useEffect(() => {
        setSelectItem(proyectSelected._id);
    }, [proyectSelected]);

    const onChangeProyect = (id) => {
        setSelectItem(id)
        dispatch(setProyectSelected(proyects.find(proyect => proyect._id === id)))
        console.log("-------------")
        dispatch(setProyectSelectedTraining(proyects.find(proyect => proyect._id === id)))
        if (typeAdmin === "VRT") {
            dispatch(getAllResponsesTrainingFormProject(id))
        }
        else {
            dispatch(getAllResponsesFormProject(id))
            dispatch(getAllGroups(id))
        }
    }
    // if (options.length > 0) {
    //     setSelectItem(options[0]._id)
    // }
    return (
        <div className="w-full h-full flex justify-between items-center py-3 px-6">
            <div className="flex ">
                <div className="w-[150px] xl:w-[248px] h-8  mr-6 bg-white">
                    {proyects.length > 0 && (
                        <CustomSelect selectedItem={itemSelected} label="Selecciona una capacitación" change={onChangeProyect} items={proyects} />
                    )}
                </div>
                <div className="w-[248px] h-8 ">
                    <RangeDate

                        placeholder={["Fecha de inicio", "Fecha de fin"]} value={dateRange} onChange={(e) => setDataRange(e)} />
                </div>
            </div>
            <div className="flex">
                {/* {hasFilter && (
                    <div className="mr-4">
                        <Button
                            text="Borrar"
                            isPrincipal={false}
                            onClick={() => {
                                setSelectItem(null);
                                setDataRange(null);
                                setFilter(false);
                            }}
                        />
                    </div>
                )} */}
                <div className="mr-4">
                    <Button
                        text="Borrar"
                        //isPrincipal="false"
                        onClick={() => {
                            setSelectItem(null);
                            setDataRange(null);
                            setFilter(false);
                        }}
                        disabled={!hasFilter}
                    />
                </div>
                <Button
                    disabled={!dateRange}
                    text="Buscar" isPrincipal={true} onClick={() => setFilter(true)} />
            </div>
        </div>
    );
};
